module.exports = __webpack_public_path__ + "img/denmark.161d6403.svg";